import { render, staticRenderFns } from "./LandingComponentSpacer.vue?vue&type=template&id=a95ae1fe&scoped=true"
import script from "./LandingComponentSpacer.vue?vue&type=script&lang=js"
export * from "./LandingComponentSpacer.vue?vue&type=script&lang=js"
import style0 from "./LandingComponentSpacer.vue?vue&type=style&index=0&id=a95ae1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ae1fe",
  null
  
)

export default component.exports